<template>
	<b-row>
		<b-col cols="12" xl="12">
			<b-card no-body>
				<div slot="header" class="d-flex justify-content-between custom-card-header">
					<h5 class="card-header-title">Contragent</h5>
					<div class="card-header-actions">
						<vs-dropdown vs-custom-content vs-trigger-click>
							<b-link href.prevent class="card-header-action btn-setting" style="font-size: 1.4em">
								<i class="fa fa-th"></i>
							</b-link>
							<vs-dropdown-menu class="columns-dropdown">
								<visible-columns :default-fields="computedColumns"
												 @result="columnListener"></visible-columns>
							</vs-dropdown-menu>
						</vs-dropdown>

					</div>
				</div>
				<br>
				<b-container>
					<b-table class="generalTableClass table-responsive"
							 :key="$i18n.locale + 'table'"
							 :hover="true"
							 :striped="true" :bordered="true"
							 :small="true"
							 responsive="sm"
							 :items="[contragent]"
							 :fields="fieldsForContragents"
							 show-empty>

						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="empty" slot-scope="scope">
							<h4>{{ $t('empty') }}</h4>
						</template>
						<!-- EMPTY SLOT FOR TABLE -->

						<template slot="id" slot-scope="data">
							<strong>{{data.item.id}}</strong>
						</template>

						<template slot="shortName" slot-scope="data">
							<strong>{{data.item.shortName}}</strong>
						</template>

						<template slot="fullName" slot-scope="data">
							<strong>{{data.item.fullName}}</strong>
						</template>

						<!--									<template slot="email" slot-scope="data">-->
						<!--										<strong>{{data.item.email}}</strong>-->
						<!--									</template>-->

						<template slot="phone" slot-scope="data">
							<strong>{{data.item.phone}}</strong>
						</template>

						<!--									<template slot="mobile" slot-scope="data">-->
						<!--										<strong>{{data.item.mobile}}</strong>-->
						<!--									</template>-->

						<template slot="address" slot-scope="data">
							<strong>{{data.item.address}}</strong>
						</template>

						<!--									<template slot="address2" slot-scope="data">-->
						<!--										<strong>{{data.item.address2}}</strong>-->
						<!--									</template>-->

						<template slot="countryName" slot-scope="data">
							<strong>{{data.item.countryName}}</strong>
						</template>

						<template slot="categoryName" slot-scope="data">
							<strong>{{data.item.categoryName}}</strong>
						</template>

						<template slot="groupName" slot-scope="data">
							<strong>{{data.item.groupName}}</strong>
						</template>

						<template slot="comment" slot-scope="data">
							<strong>{{data.item.comment}}</strong>
						</template>

						<template slot="status" slot-scope="data">
							<b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
						</template>
						<template slot="actions" slot-scope="data">
							<!-- BUTTON FOR GETTING SALDO BY CONTRAGENT_ID BEGIN -->
							<b-link @click="saldoButtonPressed(data)"
									v-if="$can('get', 'saldo')"
							>
								<i class="fa fa-file-text-o"></i>
							</b-link>
							<!-- BUTTON FOR GETTING SALDO BY CONTRAGENT_ID END -->
						</template>
					</b-table>
				</b-container>
			</b-card>
		</b-col>
		<!-- DEPARTMENT SELECT MODAL FOR SALDO BEGIN  -->
		<b-modal ref="saldoDepSelectModal"
				 hide-footer
				 ok-title="Save"
		>
			<div slot="modal-header" class="posCustomModalHeader">
				<h5 slot="modal-title"
					class="mb-0"
				>
					Пожалуйста, выберите отдел
				</h5>
				<!-- SMALL LOADER -->
				<b-spinner v-if="loadingForContragent"
						   small
						   class="ml-2"
						   variant="primary"
						   label="Small Spinner"></b-spinner>
				<!-- SMALL LOADER -->
				<button
					type="button"
					class="close"
					data-dismiss="modal"
					aria-label="Close"
					@click="closeSaldoModal"
				>
					<i class="fa fa-times"></i>
				</button>
			</div>


			<b-alert
				v-if="saldoByYearError"
				:show="dismissCountDown"
				dismissible
				style="margin-bottom: 10px;"
				variant="warning"
				size="sm"
				@dismissed="dismissCountDown=0"
				@dismiss-count-down="countDownChanged"
			>
				<p>
					{{ saldoByYearErrorMessage }}
				</p>
			</b-alert>
			<div>
				<b-row>
					<b-col sm="6">
						<label for="saldoDepartmentSelect">
							<span style="color: red;">*</span>
							{{$t('pricing.department')}}
							<span style="color: red;"
								  v-if="departmentError"
							>
														{{$t('pricing.errorDepartment')}}
													</span>
						</label>
						<multiselect
							:options="departmentsWithRequisite"
							:multiple="false"
							v-model="departmentForMoneyTransfer"
							track-by="id"
							label="name"
							id="saldoDepartmentSelect"
							:show-labels="false"
							:placeholder="$t('promo-to-product.department')"
							:allow-empty="false"
							class="departmentForContragent"
						>
							<template slot="option" slot-scope="option">
								{{ option.option.name
								}} ({{ option.option.currencyCode ? option.option.currencyCode : 'no currency'
								}})
							</template>
						</multiselect>
					</b-col>
					<b-col sm="6">
						<label for="saldoYear">Год </label>
						<!--<date-picker v-model="aktForMoneyTransfer.aktDate"
                                     lang="ru"
                                     class="mb-3 pl-0"
                                     placeholder="dd-mm-yyyy"
                                     valueType="format"
                                     format="DD-MM-YYYY"
                        ></date-picker>-->
						<date-picker v-model="saldoPayload.year"
									 lang="ru"
									 class="mb-3 pl-0"
									 id="saldoYear"
									 type="year"
									 placeholder="YYYY"
									 valueType="format"
									 format="YYYY"></date-picker>
					</b-col>

				</b-row>
			</div>
			<div class="model-actions">
				<b-row class="align-items-center">
					<b-col cols="12" class="mb-3 mb-xl-0">
						<b-row class="d-flex justify-content-end">
							<b-col cols="4">
								<b-button block size="sm" type="button" @click="closeSaldoModal" variant="outline-danger">{{
									$t('actions.cancel') }}
								</b-button>
							</b-col>
							<b-col cols="4">
								<b-button block type="button"
										  size="sm"
										  @click="getSaldoByContragent"
										  variant="primary"
								>
									Посмотреть сальдо
								</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>
		</b-modal>
		<!-- DEPARTMENT SELECT MODAL FOR SALDO END  -->
	</b-row>
</template>
<script>
	import {mapActions , mapGetters, mapState} from "vuex";
	import Multiselect from 'vue-multiselect';
	import VisibleColumns from "../../views/warehouse-management/goods/blocks/VisibleColumns";
	import {TokenService} from "../../services/storage.service"

	const saldoPayloadInitial = {
		year: (new Date().getFullYear()).toString(),
		contragentId: null,
		departmentId: null
	};

	export  default  {
		name: 'Contragent',
		components: {
			Multiselect,
			VisibleColumns
		},
		data() {
			return {
				fieldsForContragents: [],
				departmentError: false,
				departmentForMoneyTransfer: null,
				saldoPayload: Object.assign({}, saldoPayloadInitial),

			}
		},
		computed: {
			contragentId() {
				return TokenService.getContrAgentId()
			},
			...mapState('departments', [
				'departmentsWithRequisite'
			]),
			...mapState('contragents', [
				'loadingForContragent',
				'notAllowedError',
				'deleteContragentErrorMessage',
				'createError',
				'createContragentErrorMessage',
				'moneyTransferError',
				'moneyTransferErrorMessage',
				'saldoByYearError',
				'saldoByYearErrorMessage',
				'currentContragentForTransfer'
			]),
			...mapGetters('contragents', [
				'contragent'
			]),
			computedColumns() {
				return [
					{
						key: 'id',
						label: 'Id',
						visible: true,
						changebale: true
					},
					{
						key: 'fullName',
						label: this.$t('incomes.block-unit.name'),
						visible: true,
						changebale: true
					},
					/*{
						key: 'shortName',
						label: this.$t('contragent.short-name'),
						visible: false,
						changebale: true
					},*/
					/*{
						key: 'email',
						label: this.$t('Email'),
						visible: true,
						changebale: true
					},*/
					{
						key: 'phone',
						label: this.$t('contragent.phone'),
						visible: true,
						changebale: true
					},
					/*{
						key: 'mobile',
						label: this.$t('contragent.mobile'),
						visible: false,
						changebale: true
					},*/
					{
						key: 'address',
						label: this.$t('contragent.address'),
						visible: true,
						changebale: true
					},
					/*{
						key: 'address2',
						label: this.$t('contragent.address2'),
						visible: false,
						changebale: true
					},*/
					/*{
						key: 'countryName',
						label: this.$t('contragent.country-name'),
						visible: true,
						changebale: true
					},*/
					{
						key: 'categoryName',
						label: this.$t('contragent.category-name'),
						visible: true,
						changebale: true
					},
					{
						key: 'groupName',
						label: this.$t('contragent.group-name'),
						visible: true,
						changebale: true
					},
					{
						key: 'bankAccount',
						label: this.$t('contragent.bank'),
						visible: true,
						changebale: true
					},
					{
						key: 'vatAccount',
						label: this.$t('contragent.ndc'),
						visible: true,
						changebale: true
					},
					{
						key: 'comment',
						label: this.$t('comment'),
						visible: true,
						changebale: true
					},
					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions',
						visible: true,
						changebale: true
					}

				]
			}
		},
		methods: {
			columnListener($event) {
				this.fieldsForContragents = this.filterColumns($event)
			},
			...mapActions('departments', [
				'getDepartmentsForContragent'
			]),
			async saldoButtonPressed(data) {
				this.departmentForMoneyTransfer = null;
				this.$store.commit('contragents/setCurrentContragentForTransfer', data.item);
				// this.currentContragentForTransfer = data.item;
				this.$refs.saldoDepSelectModal.show();
				await this.getDepartmentsForContragent();
			},
			...mapActions('contragents', [
				'getSaldoList',
				'getContragentStoreById'
			]),
			async getSaldoByContragent() {
				if(this.departmentForMoneyTransfer) {
					this.saldoPayload.departmentId = this.departmentForMoneyTransfer.id;
					this.saldoPayload.contragentId = this.currentContragentForTransfer.id;
					if (this.saldoPayload.year) {
						if (this.saldoPayload.year.length < 4) {
							this.saldoPayload.year = (new Date().getFullYear()).toString();
						}
					} else {
						this.saldoPayload.year = (new Date().getFullYear()).toString();
					}

					await this.getSaldoList(this.saldoPayload);
					if (!this.saldoByYearError) {
						this.$router.push({path: `/contragent/${this.currentContragentForTransfer.id}/saldo`});
						this.closeSaldoModal();
					} else {
						setTimeout(() => {
							this.$store.commit('contragents/setSaldoByYearError', {message: '', boolean: false})
						}, 4000)
					}
				} else {
					this.$vs.notify({
						text: 'Выберите отдел',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			closeSaldoModal() {
				this.$refs.saldoDepSelectModal.hide();
			},
			filterColumns(columns = []) {
				return columns.filter(column => {
					if (column.visible) {
						return column
					}
				})
			},
		},
		async mounted() {
			this.fieldsForContragents = this.filterColumns(this.computedColumns);
			await  this.getContragentStoreById(this.contragentId)
		},
		watch: {
			/* FOR TABLE HEADER TRANSLATION ISSUE */
			computedColumns (val) {
				this.fieldsForContragents = this.filterColumns(val);
			},
			/* WATCHERS FOR FILTER END */
			'departmentForMoneyTransfer': {
				handler(newVal) {
					if (newVal) {
						this.$store.commit('contragents/setCurrentDepartmentForMoneyTransfer', newVal);
					} else {
						this.$store.commit('contragents/setCurrentDepartmentForMoneyTransfer', null);
					}
				}
			}
		},

	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.form-group select {
		color: #000;
	}
	.posCustomModalHeader {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;

	.close {
		font-size: 14px;
		}
	}
</style>
